export default __webpack_public_path__ + "media/images/shelter-splat-0ad7681db3d4fc677451aa996771ac87.svg";